import { render, staticRenderFns } from "./offerConfigure.vue?vue&type=template&id=742d2e6a&scoped=true&"
import script from "./offerConfigure.vue?vue&type=script&lang=js&"
export * from "./offerConfigure.vue?vue&type=script&lang=js&"
import style0 from "./offerConfigure.vue?vue&type=style&index=0&id=742d2e6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742d2e6a",
  null
  
)

export default component.exports